import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

const colorBarHeight = 3;
const cardPadding = 8;

export const EmptyRegistryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  background-color: #f9f9f9;
`;

export const TitleHeader = styled.div`
  font-size: 27px;
  font-weight: 600;
  padding: 25px;
`;

export const TitleDescription = styled.div`
  width: 530px;
  margin-bottom: 20px;
  font-size: 17px;
  color: #787877;
`;

export const Quickstart = styled.div`
  width: 600px;
  background-color: white;
  padding: 25px;
  border-radius: 15px;
  border: 1px solid #e3e2e1;
  margin-bottom: 40px;
`;

export const SectionHeader = styled.div`
  font-size: 22px;
  font-weight: 500;
`;

export const SectionText = styled.div`
  margin-bottom: 25px;
  font-size: 18px;
  margin-top: 10px;
`;

export const IframeContainer = styled.div`
  text-align: center;
`;

export const QuickstartListContainer = styled.div`
  font-size: 18px;
  margin-bottom: 25px;
  > ol {
    padding-left: 20px;
  }

  > ol > li.checked-quickstart-step:first-child:before {
    content: '✓';
    position: relative;
    right: 20px;
    display: inline-block;
    background: white;
    font-size: 22px;
    color: lightgrey;
  }

  > ol > li {
    margin-bottom: 20px;
  }
`;

export const GeneralPageContainer = styled.div`
  flex: 1 1 auto;
  width: 100%;
  overflow-x: hidden;
  min-height: calc(
    100vh - ${globals.SEARCH_NAV_HEIGHT}
  ); // account for top nav bar
`;

export const RegistryContents = styled.div`
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  overflow: hidden;
  padding-top: 1px;
  padding-bottom: ${cardPadding}px;
`;

export const MinimizedSidebar = styled.div`
  padding-top: 20px;
  height: 100%;
  width: 60px;
  text-align: center;
`;

export const CollectionDetailViewContainer = styled.div`
  height: 100%;
  width: 100%;
  flex: 1 1 auto: 
  padding-right: ${cardPadding}px;
  overflow: hidden;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
`;

export const CollectionDetailView = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
  /* padding: 15px; */
`;
